import { render, staticRenderFns } from "./SidebarNavDropdown.vue?vue&type=template&id=dfc030b8&scoped=true"
import script from "./SidebarNavDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarNavDropdown.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavDropdown.vue?vue&type=style&index=0&id=dfc030b8&prod&scoped=true&lang=css"
import style1 from "./SidebarNavDropdown.vue?vue&type=style&index=1&id=dfc030b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc030b8",
  null
  
)

export default component.exports